import { useTranslate } from "@/hooks";
import { resolveTranslatedLabel } from "@/utils";

export const resolveSidebarLabel = (
  translate: ReturnType<typeof useTranslate>,
  name: string,
): string => resolveTranslatedLabel(translate, name, "navigation");
